<template>
  <el-header class="header">
    <!-- 左侧留空 -->
    <div class="header-left"></div>

    <!-- 中间部分 -->
    <div class="header-center">
      <img
        src="https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250124/20250124022223d3ff57715.png"
        class="center-icon"
        alt="分销中心"
        @click="showDistributionMessage"
      />

      <!-- 优惠套餐 -->
      <img
        src="https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250124/20250124022252e6a6e7577.png"
        class="center-icon"
        alt="优惠套餐"
        @click="showPackageMessage"
      />
      <!-- 算力 -->
      <span class="compute-power">
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAApFJREFUWEftl/0xBEEQxZ8IEAEiQASIABEgAkSACBABIkAEiAAROBEgA/e7mnfVNze7O+uj/KOrtvbudrb79evPm9Efy8wf21dfAIuSfM1Kmk8OvEn6kDSQ9CTpvdaxLgBzknYkraeL7zUCgHtJN5IeErDie00AMHiUjNYY7DpzKemkBCQHgIcYPsg04hHeQO9runPEVPOer+UEfCWFK6o6G4bqMP4QAaDgbmiIFy0gv0p0dnlZeg6TuymMfo4TGwYfAWCMeCPEb68tdj3RkLjXwbkxEwbAgZekFKq3exqoPQ7DsIJQQe8GsJUQ8gB6YOA3ZMqOARD3x2SRbD3+Despwa175GjMAUJAKBAylTj9pOwHnTSsJZRHAJEeJyJsfDccpZ6y6lJuqoLoOWhvQx/oarOUszvnZqEX2DlCMGYgrwKaDZSVBADUMsJnLt7HsO/5e5w5T2eslxAM2qoAZXjiWfCVfPA8oJkBoqoKptplQk6lAGgh0OqkNROehjCI8TxctHlXwSgPYg7EJsEhEvAn5TTMmGIV4B0gLBwCCPR9VcgLaMdzs4WucbNrYiAajLP9OSRgCZQTcS31fYyXdgjCM1EFsRMylFgictQ5KBhyjO1d9DI/n1fBRA40zQJGKbVMeGq3IRs2cx7nfI9hxuZtaRaUqgClXjC4x0qI/YDsdyW4V0Qm4shvrQJAUAVdXa82OfNNazzyYxISP6rAcXQVtC6VHQgwTOdjxXMI0UsCcp9ayzF+UVhGyVqAuLmU6EUf7xMi74VePoxzatNq2opJvrYqiHHnsxfSJkIwTBVA/YR0/S/wUolHcVmtiX2coo0jvQtANISXppd9jkqIQgXwD6lpDhRB9wFQ43XvM/8APgHOQKchNZgYUAAAAABJRU5ErkJggg=="
          class="center-icons" alt="算力" />
        {{ computedPowerText }}
      </span>

      <el-dropdown>
        <template #default>
          <div class="user-menu">
            <img src="https://jzguai01.oss-cn-shanghai.aliyuncs.com/uploads/images/20250124/20250124022137ef23e0618.png"
              class="avatar" alt="头像" />
            <span class="account">{{ account }}</span>
            <el-icon>
              <ArrowDown />
            </el-icon>
          </div>
        </template>
        <template #dropdown>
          <el-dropdown-item @click="showChangePasswordModal">
            修改密码
          </el-dropdown-item>
          <el-dropdown-item divided @click="logout">退出登录</el-dropdown-item>
        </template>
      </el-dropdown>
    </div>

    <!-- 修改密码弹窗 -->
    <el-dialog title="修改密码" v-model="isChangePasswordVisible" width="400px" :before-close="handleClose">
      <el-form :model="passwordForm" :rules="rules" ref="passwordFormRef" label-width="100px">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" v-model="passwordForm.oldPassword" autocomplete="current-password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="passwordForm.newPassword" autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input type="password" v-model="passwordForm.confirmPassword" autocomplete="new-password"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="isChangePasswordVisible = false">取消</el-button>
        <el-button style="background-color: #ff5c00;border: none;" type="primary" @click="submitChangePassword">确定</el-button>
      </template>
    </el-dialog>
  </el-header>
</template>

<script>
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import { auth } from "@/utils/auth.js";
import axios from "axios";
import config from "@/config.js"; // 引入配置文件
import { ElMessage } from "element-plus";
export default {
  name: "AppHeader", // 使用多单词名称以符合 ESLint 规则
  components: {
    ...ElementPlusIconsVue,
  },
  props: {
    account: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isChangePasswordVisible: false,
      passwordForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      localComputing: -1, // 本地算力
      cloudComputing: -1, // 云端算力
      rules: {
        oldPassword: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码长度不能少于6位", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请确认新密码", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error("两次输入密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    // 动态生成算力显示文本
    computedPowerText() {
      if (this.localComputing !== -1 && this.cloudComputing === -1) {
        return `本地算力：${this.localComputing}`;
      } else if (this.cloudComputing !== -1 && this.localComputing === -1) {
        return `云端算力：${this.cloudComputing}`;
      } else if (this.localComputing !== -1 && this.cloudComputing !== -1) {
        return `本地算力：${this.localComputing}`;
      } else {
        return "算力：0";
      }
    },
  },
  methods: {
    logout() {
      auth.clearUser();
      this.$router.push("/login");
    },
    showChangePasswordModal() {
      this.isChangePasswordVisible = true;
    },
    handleClose(done) {
      this.$refs.passwordFormRef.resetFields();
      done();
    },
        // 显示分销中心提示信息
        showDistributionMessage() {
      ElMessage({
        message: "分销中心正在开发中，请稍后···",
        type: "info",
      });
    },
    // 显示优惠套餐提示信息
    showPackageMessage() {
      ElMessage({
        message: "优惠套餐正在开发中，请稍后···",
        type: "info",
      });
    },
    async queryData() {
      try {
        const response = await axios.post(
          `${config.BASE_URL}/pc/api/store_api.php`,
          {
            action: "query",
            account: this.account,
          }
        );

        if (response.data.success) {
          // 更新本地算力和云端算力
          this.localComputing = parseFloat(response.data.data.local_computing);
          this.cloudComputing = parseFloat(response.data.data.cloud_computing);
        } else {
          this.$message({
            message: response.data.message || "查询失败",
            type: "error",
          });
        }
      } catch (error) {
        console.error(error);
        this.$message({
          message: "网络错误，请稍后再试",
          type: "error",
        });
      }
    },
    submitChangePassword() {
      this.$refs.passwordFormRef.validate(async (valid) => {
        if (valid) {
          try {
            const response = await axios.post(
              `${config.BASE_URL}/pc/api/store_api.php`,
              {
                action: "update_password",
                account: this.account,
                old_password: this.passwordForm.oldPassword,
                new_password: this.passwordForm.newPassword,
              }
            );

            if (response.data.success) {
              this.$message({
                message: "密码修改成功，请重新登录",
                type: "success",
              });
              auth.clearUser();
              this.$router.push("/login");
            } else {
              this.$message({
                message: response.data.message || "密码修改失败",
                type: "error",
              });
            }
          } catch (error) {
            console.error(error);
            this.$message({
              message: "网络错误，请稍后再试",
              type: "error",
            });
          } finally {
            this.isChangePasswordVisible = false;
            this.$refs.passwordFormRef.resetFields();
          }
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },
  },
  mounted() {
    // 组件挂载时调用查询方法
    this.queryData();
  },
};
</script>

<style scoped>
.header {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 60px;
  border-bottom: 1px solid #eaeaea;
}

.header-center {
  display: flex;
  align-items: center;
  gap: 16px;
}

.center-icon {
  width: 120px;
  height: 40px;
  cursor: pointer;
}

.center-icons {
  width: 20px;
  height: 25px;
  cursor: pointer;
  margin-right: 5px;
}

.compute-power {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  display: flex;
  align-items: center;
  margin-right: 60px;
  gap: 4px;
}

.user-menu {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.account {
  font-size: 14px;
  color: #333;
  font-weight: bold;
}

.el-icon {
  font-size: 16px;
  color: #333;
}
</style>